<template>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center p-2 mb-1 border-bottom">
	<div class="fs-4">
		Історія змін налаштувань КВП
	</div>

	<!-- Choose table type urttons -->
	<!-- <div class="d-inline-block ">
		<button
			type="button"
			class="btn btn-sm btn-outline-secondary m-0 mx-1 p-2"
			@click="tableType = 1"
			style="border: 1; height: 2.4rem; aspect-ratio: 1 / 1;"
		>
			1
		</button>

		<button
			type="button"
			class="btn btn-sm btn-outline-secondary m-0 mx-1 p-2"
			@click="tableType = 2"
			style="border: 1; height: 2.4rem; aspect-ratio: 1 / 1;"
		>
			2
		</button>
	</div> -->
</div>

<PostsPassportHistoryTable />
<!-- <PostsPassportHistoryTable2 v-if="tableType == 2" /> -->
</template>




<script>
import PostsPassportHistoryTable from './PostsPassportHistoryTable.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { usePostsStore } from '@/stores/PostsStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { Post } from '@/models/post.js'

export default {
	inject: [ 'headerHeight'],
	
	components: {
		PostsPassportHistoryTable,
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()

		return {
			accountStore,
			postsStore,
			stationsStore,
			sessionStore,
			Post,
		}
	},

	data() {
		return {
			// Table
			// tableType: 1,
		}
	},

	async created() {},

	mounted() {
		document.title = "Історія налаштувань КВП"
	},

	methods: {},

	computed: {},
}
</script>




<style src="@/assets/table.css" scoped></style>